import { post } from './utils'

class UnsubscribeApi {
  static create() {
    return post(`/unsubscribe`)
  }
}

export default UnsubscribeApi
